import React, {Fragment} from "react";
import image from '../../../images/situation/maten/kozijn/S.jpg'

export default function MaatS(props) {
    return <Fragment>
        <div className="addtextMore">
            Voor kaderluiken zoals paneel- of louvreluiken vult u hier de stijlbreedte (S) in mm in.
        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}